import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { take, map } from 'rxjs/operators';

import { UserService } from '../services/shared/user.service';
import { RoutingService } from '../services/routing.service';
import { AppSettingsService, SubdomainEnum } from '../services/app-settings.service';
@Injectable({
  providedIn: 'root'
})
export class AuthorizedGpGuard  {

  constructor(
    private userService: UserService,
    private appSettingsService: AppSettingsService,
    private routingService: RoutingService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    boolean |
    UrlTree |
    Observable<boolean | UrlTree> |
    Promise<boolean | UrlTree> {

    const userIsLoggedIn = this.userService.isLoggedIn();
    // If the user is not logged in,
    // or trying to access an LP page from the GP website,
    // redirect to the login page by the subdomain
    if (!userIsLoggedIn) {
      // if the user is not logged in, we can tell to which Login page to redirect him by the 'subDomain' appSettings value.
      return of(this.routingService.getLoginUrlTree(false, true));
    // } else if (this.appSettingsService.subDomain === SubdomainEnum.LP) {
    //   return of(this.routingService.getLoginUrlTree(true));
    } else {
      // return this.userService.accountDetails$
      //   .pipe(map(clientDetails => {
      //     // User is not GP - redirect to login
      //     if (!clientDetails.isAgent) {
      //       return this.routingService.getLoginUrlTree();
      //     }
          // user is GP
          return true;
          // }));
        // }));
    }
  }
}
